import { render } from "./AccountingDatatableTDDate.vue?vue&type=template&id=da390b4c"
import script from "./AccountingDatatableTDDate.vue?vue&type=script&lang=js"
export * from "./AccountingDatatableTDDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__